import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { AllDataBreeding } from "../../../api/breeding";
import { sectionToIcon } from "../../type/default";
import { DeviceTypeBadge } from "../device/DeviceTypeBadge";

type BreedingCardProps = {
  data: AllDataBreeding;
  onSelect: () => void;
};

export const BreedingCard = ({ data, onSelect }: BreedingCardProps) => {
  const { t } = useTranslation();
  const uniqueDeviceTypes = Array.from(
    new Set(data.devices.map((device) => device.type))
  );

  return (
    <button
      type="button"
      onClick={onSelect}
      className="w-full text-left bg-white rounded-xl overflow-hidden transition-transform hover:scale-[1.01] focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary"
      style={{
        boxShadow: "0px 4px 8px #b4b4b4",
      }}
    >
      <div className="flex items-center gap-3 px-4 py-3 bg-grey-light">
        <FontAwesomeIcon
          icon={sectionToIcon.section_breeding}
          className="text-tertiary"
        />
        <div className="flex-1 font-oxaniumMedium truncate">
          {data.breeding.name}
        </div>
      </div>

      <div className="px-4 py-3 border-t border-grey-light">
        <div className="text-grey-medium text-sm font-oxaniumMedium mb-1">
          {t("section-building")}
        </div>
        <div className="text-default-text truncate">
          {data.buildings.map((building) => {
            return <div key={building.id}>{building.name}</div>;
          })}
        </div>
      </div>

      <div className="px-4 py-3 border-t border-grey-light">
        <div className="text-grey-medium text-sm font-oxaniumMedium mb-2">
          {t("section-devices")}
        </div>
        {uniqueDeviceTypes.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {uniqueDeviceTypes.map((type) => (
              <DeviceTypeBadge key={type} type={type} />
            ))}
          </div>
        ) : (
          <div className="text-default-text">-</div>
        )}
      </div>
    </button>
  );
};
